export const ORIGIN = 'https://andiscarola.com';
export const PAGES = {
  '/': ['Andi Scarola | Software Engineer & AI Researcher', 'Andi Scarola is a software engineer, AI researcher, and founder in El Paso. Explore her research, products, and computer vision projects.'],
  '/projects': ['Projects | Andi Scarola', 'Explore Andi Scarola’s work in applied AI, computer vision, manufacturing software, and product development, plus past hackathon projects.'],
  '/about': ['About | Andi Scarola', 'Meet Andi Scarola, a software engineer, AI researcher, and founder and AI graduate student at UTEP in El Paso.'],
  '/contact': ['Contact | Andi Scarola', 'Get in touch with Andi Scarola about software engineering, AI research, and collaboration.'],
};

